import requests from "./httpService";

const UserServices = {
    getSingleUser : async (qurery) =>{
          
        return requests.get(`/user/userlist?query=${qurery}`);
    },
    getAllUser : async () =>{
   
        return requests.get(`/user`);
    },
    getAllInvestor : async () =>{
   
        return requests.get(`/user/investor`);
    },
    getCity : async () =>{
   
        return requests.get(`/user/city`);
    },
    createUser : async (body) =>{
        // console.log(body)
        return requests.post(`/user/`,body);
    },
    createInvestor : async (body) =>{
        // console.log(body)
        return requests.post(`/user/investor`,body);
    },
   
    updateUser : async (id,body) =>{
        // console.log(">>>>",body)
        return requests.patch(`/user/${id}`,body);
    },
    updateInvestor: async (id,body) =>{
        // console.log(">>>>",body)
        return requests.patch(`/user/investor/${id}`,body);
    },
    updateUserStatus : async (id,body) =>{
        // console.log(">>>>",body)
        return requests.patch(`/user/status/${id}`,body);
    },
    deleteUser: async (id,body) =>{
        return requests.delete(`/user/${id}`,body);
    },
    deleteInvestor: async (id,body) =>{
        return requests.delete(`/user/investor/${id}`,body);
    },
   
  
   
    

   


}

export default UserServices;